import { useEffect, useRef } from 'react';
// https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
export function usePrevious(value, initial) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current || initial;
}
